/**
   * Handle products
   */
const
    body = $('body'),
    disclaimerBox = $('#disclaimerBox'),
    disclaimerTrigger = $('#disclaimerTrigger'),
    subscribeMode = $('#subscribeMode');

//- Select Subscribe option if click on disclaimer box title
disclaimerTrigger.on("click", function () {
    let checkbox = $('#subscribeCheckbox');
    let cartBtn = $('#cartCta');

    checkbox.toggleClass('checked');
    cartBtn.toggleClass('disabled');
});

// close disclaimer box
$('#closeDisclaimer').on('click', function () {
    disclaimerBox.removeClass('subscribe-box__disclaimer--open');
});

// Select Product Option - extended functionality to switch between products
$('.product-switch__option').on('click', function () {
    let thisProduct = $(this);
    let thisProductAttr = thisProduct.attr('data-product-option');

    if (!thisProduct.hasClass('active')) {
        $('.product-switch__option').removeClass('active');
        thisProduct.addClass('active');
    }

    //- assign the chosen product attr to its parent
    thisProduct.parent().attr('data-product', thisProductAttr);

    $('.cart__product.active').trigger("click");
})

// Subscribe Mode
$('.subscribe-box__default').on('click', function () {
    let thisBtn = $(this);
    let cartBtn = $('#cartCta');
    let checkbox = $('#subscribeCheckbox');
    let checkboxWrap = $('.subscribe-box__wrap');

    $('.subscribe-box__default').removeClass('active');
    thisBtn.addClass('active');

    if (thisBtn.hasClass('subscribe')) {
        checkboxWrap.addClass('isSubscribe');
    } else {
        checkboxWrap.removeClass('isSubscribe');
    }

    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    //- reset all UIs
    if (cartBtn.hasClass('disabled')) {
        cartBtn.removeClass('disabled');
    }

    if (checkbox.hasClass('checked')) {
        checkbox.removeClass('checked');
    }

    //- set 'data-subscribe' value + control UI
    if (thisBtn.hasClass('subscribe')) {
        subscribeMode.attr('data-subscribe', 'true');

        if (!cartBtn.hasClass('disabled')) {
            cartBtn.addClass('disabled');
        }

        if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.addClass('subscribe-box__disclaimer--open');
        }

    } else {
        subscribeMode.attr('data-subscribe', 'false');

        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    $('.cart__product.active').trigger("click");
});

function activeProduct() {
    let thisProduct = $(this);
    let subscribeAttr = $('#subscribeMode').attr('data-subscribe');
    let chooseProductAttr = $('#chooseProduct').attr('data-product');

    const retail = thisProduct.attr('data-retail');

    let price,
        regularity,
        link,
        subscribeSave,
        shipping,
        alternativeContentValue,
        badge,
        unit = thisProduct.attr('data-units');

    $('.cart__products').removeClass('unit-1 unit-3 unit-6').addClass('unit-' + unit);

    if (thisProduct.attr('data-stamp')) {
        badge = thisProduct.attr('data-stamp');
    }

    if ($('#chooseProduct').length && chooseProductAttr === 'optional') {
        if (subscribeAttr === 'true') {
            link = 'data-option-subscribe-tracker';

        } else {
            link = 'data-option-tracker';
        }

        $('.cart__image-default').removeClass('show').addClass('hide');
        $('.cart__image-optional').removeClass('hide').addClass('show');

    } else {
        if (subscribeAttr === 'true') {
            link = 'data-subscribe-tracker';

        } else {
            link = 'data-tracker';
        }

        $('.cart__image-default').removeClass('hide').addClass('show');
        $('.cart__image-optional').removeClass('show').addClass('hide');
    }

    if (subscribeAttr === 'true') {
        price = 'data-subscribe-amount';
        regularity = '<span>/month</span>';
        shipping = 'data-subscribe-shipping';
        alternativeContentValue = '';

        // $('.current__value').html(thisProduct.attr(price) + '<span>/month</span>');

    } else {
        price = 'data-amount';
        regularity = '';
        shipping = 'data-shipping',
        alternativeContentValue = $('#alternativeContent').attr('data-alt-content');

        // $('.current__value').html(thisProduct.attr(price));
    }

    $('.cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('.current__value').html(thisProduct.attr(price) + regularity);
    $('.retail__value').html(retail);
    $('.perUnit__value').html(parseFloat(thisProduct.attr(price) / unit).toFixed(2));
    $('.shipping__value').html((thisProduct.attr(shipping)));

    $('#alternativeContent').html(' ' + alternativeContentValue);

    // if (unit == '3' || unit == '6') {
    //     if (!$('.shipping').hasClass('hide')) {
    //         $('.shipping').addClass('hide');
    //     }
    // } else {
    //     $('.shipping').removeClass('hide');
    // }

    if (unit == '1' && subscribeAttr === 'true') {
        subscribeSave = 'data-subscribe-save';

        $('.saving__value').html(thisProduct.attr(subscribeSave));
    } else {
        // $('.saving__value').html(parseFloat((retail - thisProduct.attr(price)).toFixed(2)));

        //- Save per Unit
        $('.saving__value').html(((retail - thisProduct.attr(price)) / unit).toFixed(2));
    }

    // Images to show according to the product unit
    $('.cart__image-item').removeClass('show').addClass('hide');
    $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

    //- prints Best value per package
    if( badge == undefined){
        $('#stamp, #ribbon').hide();
    }else if ($('#value').length) {
        $('#stamp, #ribbon').show();
        $('#value').html(badge);
    }

    //- handle CTA by ID
    let param = $('#cartCta').attr('data-param');
    $('#cartCta').attr('href', thisProduct.attr(link) + param);
}

$('.cart__product').on('click', activeProduct);
$('.cart__product.active').trigger("click");



// function isInViewport(el) {
//     const rect = el.getBoundingClientRect();
//     return (
//         rect.top >= 0 &&
//         rect.left >= 0 &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//         rect.right <= (window.innerWidth || document.documentElement.clientWidth)

//     );
// }


// const box = document.querySelector('#cartCta');

// document.addEventListener('scroll', function () {
//     isInViewport(box) ?
//      document.querySelector('.stickyCTA').classList.remove('off')
//     :
//         '';

// }, {
//     passive: true
// });